import { render, staticRenderFns } from "./CTicketForm.vue?vue&type=template&id=65836df4&"
import script from "./CTicketForm.vue?vue&type=script&lang=js&"
export * from "./CTicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports